"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractPaletteQuantizer = /** @class */ (function () {
    function AbstractPaletteQuantizer() {
    }
    AbstractPaletteQuantizer.prototype.quantize = function () {
        try {
            for (var _a = __values(this.quantizeAsync()), _b = _a.next(); !_b.done; _b = _a.next()) {
                var value = _b.value;
                if (value.palette) {
                    return value.palette;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_1) throw e_1.error; }
        }
        throw new Error('unreachable');
        var e_1, _c;
    };
    return AbstractPaletteQuantizer;
}());
exports.AbstractPaletteQuantizer = AbstractPaletteQuantizer;
//# sourceMappingURL=paletteQuantizer.js.map